import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonTabs } from '@ionic/angular/standalone';
import { Router } from '@angular/router';
import { IconButtonComponent } from 'src/app/ui-kit/icon-button/icon-button.component';
import { WavyDividerComponent } from 'src/app/ui-kit/wavy-divider/wavy-divider.component';
import { SideMenuState } from 'src/app/store/side-menu';
import { NavigationPanelComponent } from 'src/app/layout/page/panels';
import { NavigationPanelContainerComponent } from 'src/app/layout/page/panels/navigation-panel-container/navigation-panel-container.component';
import { NavigationPanelTabsContainerComponent } from 'src/app/layout/page/panels/navigation-panel-tabs-container/navigation-panel-tabs-container.component';
import { NavigationMenuItem, NavigationMenuItemComponent } from 'src/app/layout/page/panels/navigation-menu-item/navigation-menu-item.component';

@Component({
  selector: 'app-blume-admin',
  templateUrl: './blume-admin.component.html',
  styleUrls: ['./blume-admin.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonTabs,
    WavyDividerComponent,
    NavigationPanelContainerComponent,
    NavigationPanelComponent,
    NavigationPanelTabsContainerComponent,
    NavigationMenuItemComponent,
    IconButtonComponent,
  ],
  host: {
    class: 'contents',
  },
})
export class BlumeAdminComponent {

  private readonly sideMenuState = inject(SideMenuState);
  private readonly router = inject(Router);

  readonly sideMenuExpanded = computed(() => this.sideMenuState.sideMenuExpanded());

  adminMenuItems: NavigationMenuItem[] = [
    {
      label: 'Home',
      iconInactive: 'home-outline',
      iconActive: 'home',
      route: '/blume-admin/home',
      highlightColor: 'purple',
    },
    {
      label: 'Partners',
      iconInactive: 'partner-outline',
      iconActive: 'partner',
      route: '/blume-admin/partners',
      highlightColor: 'purple',
    },
    {
      label: 'Accounts',
      iconInactive: 'people-outline',
      iconActive: 'people',
      route: '/blume-admin/accounts',
      highlightColor: 'purple',
    },
    // {
    //   label: 'Skills',
    //   iconInactive: 'school-outline',
    //   iconActive: 'school',
    //   route: '/blume-admin/skills',
    //   highlightColor: 'purple',
    // },
    {
      label: 'Activity',
      iconInactive: 'pulse-outline',
      iconActive: 'pulse',
      route: '/blume-admin/activity',
      highlightColor: 'purple',
    },
    {
      label: 'Staff',
      iconInactive: 'badge-outline',
      iconActive: 'badge',
      route: '/blume-admin/staff',
      highlightColor: 'purple',
    },
    {
      label: 'Profile',
      iconInactive: 'person-outline',
      iconActive: 'person',
      route: '/blume-admin/profile',
      highlightColor: 'purple',
    },
  ];

  academyMenuItems: NavigationMenuItem[] = [
    {
      label: 'Blueprints',
      iconInactive: 'bookmark-outline',
      iconActive: 'bookmark',
      route: '/blume-admin/academy/modules',
      highlightColor: 'purple',
    },
    {
      label: 'Workshops',
      iconInactive: 'calendar-outline',
      iconActive: 'calendar',
      route: '/blume-admin/academy/workshops',
      highlightColor: 'purple',
    },
    {
      label: 'Portfolio',
      iconInactive: 'folder-outline',
      iconActive: 'folder',
      route: '/blume-admin/academy/portfolio',
      highlightColor: 'purple',
    },
  ];

  appsMenuItems: NavigationMenuItem[] = [
    {
      label: 'My Blume',
      iconInactive: 'flower-1',
      iconActive: 'flower-1',
      route: '/home',
      highlightColor: 'purple',
    },
    {
      label: 'Notebook',
      iconInactive: 'notebook-outline',
      iconActive: 'notebook',
      route: '/notebook',
      highlightColor: 'purple',
    },
    {
      label: 'Academy',
      iconInactive: 'school-outline',
      iconActive: 'school',
      route: '/academy',
      highlightColor: 'purple',
    },
   
  ];

  toggleSideMenu(): void {
    this.sideMenuState.toggleSideNavExpanded();
  }

  navigateTo(route: string): void {
    this.sideMenuState.collapseSideNavOnSmallScreens();
    this.router.navigate([route]);
  }
}
